<template>
  <div class="side-links">
    <a href="#" v-if="$route.name != 'Home'" @click.stop.prevent="showTableContents" class="content-toggler" >{{$t('togglerBtn.text')}}</a>
    <ul class="file-actions">
      <li>
        <button @click.prevent="changeLocale(otherLocale)" class="lang-btn ar">{{ otherLangText }}</button>
      </li>
      <li v-show="this.$i18n.locale=='ar'">
        <a href="https://d364xagvl9owmk.cloudfront.net/media-10-4-18/media/filer_public/12/a2/12a26009-d8a9-4d6c-b30a-2177edcaafa6/zain_2021tlr_arabic.pdf" target="_blank" class="download">
          <i class="fa fa-download"></i>
        </a>
      </li>
      <li v-show="this.$i18n.locale=='en'">
        <a href="https://d364xagvl9owmk.cloudfront.net/media-10-4-18/media/filer_public/ab/2e/ab2ee2f0-9ffd-4e56-ba3e-014b61babf5b/zain_2021tlr_english.pdf" target="_blank" class="download">
          <i class="fa fa-download"></i>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      homePage: false
    };
  },
  methods: {
    showTableContents() {
      document.body.classList.add("isVisible");
    },
    changeLocale(locale) {
        // localStorage.language = locale
        this.$i18n.locale = locale
        console.log(locale);
        this.$router.push({
            params: {lang: locale}
        })
        this.$router.go()
    },
  },
  computed:{

    otherLangText() {
        
        return this.$i18n.locale === 'ar' ? 'English' : 'العربية'
    },
    otherLocale() {
        return this.$i18n.locale === 'en' ? 'ar' : 'en'
    },
  },
};
</script>
<style lang="scss" scoped>
.content-toggler {
  background: #76326b;
  color: #ffffff;
  padding: 10px;
  display: inline-block;
  font-size: 14px;
  position: fixed;
  top: 50%;
  margin-top: -135px;
  left: 0;
  z-index: 9;
  transform: rotate(90deg);
  transform-origin: 15px;
  border-radius: 5px 5px 0px 0;
  min-width:128px;
  min-height: 34px;
  text-align: center;
  @media screen and (min-width: 1024px) {
    &:hover {
      opacity: 0.6;
    }
  }
}
.file-actions {
  width: 34px;
  height: 120px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  position: fixed;
  z-index: 9;
  left: 0;
  top: 50%;
  margin-top: 20px;
  padding: 0;
  list-style: none;
}
.file-actions li a {
  color: #fff;
  display: block;
  background: #76326b;
  padding: 5px;
  border-radius: 0 5px 5px 0;
}
.file-actions li a:hover {
  color: #000;
  text-decoration: none;
}
.file-actions .lang-btn {
  font-size: 17px;
  transform: rotate(90deg) translate3d(0px, 0px, 0px);
  position: relative;
  left: -20px;
  top: -4px;
  height: 34px;
  min-width: 74px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px 5px 0 0;
  border:0;
  color: #fff;
  display: block;
  background: #76326b;
  outline:none !important;
  box-shadow:none !important;
  padding: 5px;
  cursor: pointer;
}
.file-actions .lang-btn:hover{
  color:#000;
}
.file-actions .lang-btn.ar {
  font-family: "qt_zain_bold";
  left: -20px;
}
.file-actions .download {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
}
.file-actions .download .fa {
  font-size: 18px;
}
.ar .file-actions {
  right: 0;
  left: auto;
}
.ar .file-actions .lang-btn {
  right: -20px;
  left: auto;
}
.ar .file-actions .lang-btn.ar {
  right: -20px;
  left: auto;
  border-radius: 0 0px 5px 5px;
}
.ar .file-actions li a {
  border-radius: 5px 0 0 5px;
}
.ar .content-toggler {
    right: 0;
    left: auto;
    margin-top: -40px;
    transform-origin: 111px;
    border-radius: 0px 0 5px 5px;
    font-family: "qt_zain_bold";
    text-align: center;
}
@media screen and (max-width: 991px) {
  .side-links {
    display: none;
  }
}
</style>
